import { Checkbox } from '@mui/material';
import { StopSharp } from '@mui/icons-material';
import { ICellRendererParams } from 'ag-grid-community';
import { useDispatch } from 'react-redux';
import { AgreementPriceRow } from './agreementPriceTypes';
import { updateAgreementPriceActiveStatus } from './redux/agreementSlices';
import { ChangeEvent, useEffect, useState } from 'react';
export const CheckboxRenderer = (params: ICellRendererParams<AgreementPriceRow>, editable: boolean) => {
    const dispatch = useDispatch();
    const [isChecked, setIsChecked] = useState(false);
    const [isEditable, setIsEditable] = useState(false);
    const changeHandler = (e: ChangeEvent<HTMLInputElement>) => {
        if (params?.data?.agreementPriceId != null && params.data.agreementPriceId > 0) {
            setIsChecked(e.currentTarget.checked);
            dispatch(
                updateAgreementPriceActiveStatus({
                    active: isChecked,
                    agreementPriceId: params.data.agreementPriceId
                })
            );
        }
    };

    useEffect(() => {
        setIsChecked(!params?.data?.isActive ?? false);
        setIsEditable(editable);
    }, [params.data?.isActive, editable, params?.data]);

    return (
        <div
            style={{
                height: '100%',
                backgroundColor: isEditable ? 'white' : 'rgba(245, 245, 245, 1)',
                margin: '0 -8px',
                textAlign: 'center',
                verticalAlign: 'center'
            }}
        >
            <Checkbox
                disabled={!isEditable}
                checked={isChecked}
                size={'small'}
                style={{ padding: 0 }}
                checkedIcon={<StopSharp />}
                color={'primary'}
                onChange={changeHandler}
            />
        </div>
    );
};
